<template>
  <div>

    <div v-if="langType === 'dropdown'">
      <Dropdown trigger="click" @on-click="selectLang" transfer :transfer-class-name="dropdownClass">
        <a href="javascript:void(0)">
          {{title}}
          <Icon :size="18" type="md-arrow-dropdown"></Icon>
        </a>
        <DropdownMenu slot="list">
          <DropdownItem v-for="(value,key) in localList" :name="key" :key="`lang-${key}`">{{ value }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <div v-if="langType === 'select'">
      <Select size="small" v-model="local"  @on-change="selectLang">
        <Option v-for="(value,key) in localList" :key="`lang-${key}`" :value="key">{{ value }}</Option>
      </Select>
    </div>

  </div>
</template>

<script>
  export default {
    name: "Language",
    props: {
      topClass:{
        type:Boolean,
        default:false
      },
      langType:{
        type:String,
        default:'dropdown'
      },
      dropdownClass:{
        type:String,
        default:''
      }
    },
    data (){
      return {
        langList: {
          'zh-CN': '语言',
          'zh-TW': '語言',
          'en-US': 'Language'
        },
        name:this.$store.state.cacheData.isEPX === '1' ? this.$t('epx_name') : (this.$store.state.cacheData.isFusion ? this.$t('document_title_fusion') : this.$t('document_title')),
      }
    },
    watch: {
      /*lang: {
        deep: true,
        immediate: true,
        handler(lang) {
          this.$i18n.locale = lang
          // document.title = this.name
        }
      },*/
      '$store.state.app.txtLogo':{
        deep: true,
        immediate: true,
        handler(val) {
          // 仅写浏览器标签；无效值跳过，避免出现 "undefined"（勿引入 util，防循环依赖白屏）
          if (val !== undefined && val !== null) {
            const s = String(val).trim()
            if (s && s !== 'undefined' && s !== 'null') {
              document.title = s
            }
          }
        }
      }
    },
    computed: {
      localList() {
        let list = this.$store.state.cacheData.languageList;
        let newList = {};
        if(list && list.length > 0){
          list.forEach(item=>{
            if("language_version_zh" === item){
              newList["zh-CN"] = "中文简体";
            }
            if("language_version_tw" === item){
              newList["zh-TW"] = "中文繁體";
            }
            if("language_version_en" === item){
              newList["en-US"] = "English";
            }
          })
          let newKey = this.local;
          newKey = newList[newKey] ? newKey : newList["en-US"] ? "en-US" : newList["zh-CN"] ? "zh-CN" : "zh-TW";
          this.selectLang(newKey);
          return newList;
        }else{
          return {
            'zh-CN': '中文简体',
            'zh-TW': '中文繁體',
            'en-US': 'English'
          }
        }
      },
      title() {
        return this.langList[this.local]
      },
      top(){
        let cl = 'custom-draw-top-no'
        if (this.topClass) {
          cl = 'custom-draw-top';
        } else {
          cl = 'custom-draw-top-no'
        }
        return cl
      },
      local:{
        get(){
          let lang = this.$store.state.app.local || 'zh-CN'
          this.$i18n.locale = lang
          this.changeCss(lang)
          return lang
        },
        set(){}
      },
    },
    methods: {
      selectLang (name){
        //语言
        this.changeCss(name)
        this.$emit('on-lang-change',name)
      },
      changeCss(lang) {
        document.documentElement.setAttribute('lang', lang)
        let node = $('body')
        this.$nextTick(() => {
          if (lang) {
            for (let key in this.langList) {
              node.removeClass(key)
              document.documentElement.classList.remove(key)
            }
            node.addClass(lang)
            document.documentElement.classList.add(lang)
          }
        })
      },
    },
  }
</script>




// WEBPACK FOOTER //
// src/components/main/components/language/language.vue